<template>
  <div :class="contextName">
    <AppHeader />
    <div class="content-all">
      <RouterView v-slot="{ Component, route }">
        <component :is="Component" v-bind="route.params" />
      </RouterView>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { RouterView } from 'vue-router'
import AppMixin from '@/base/mixins/app.mixin'
import AppHeader from '@/base/components/Header/AppHeader'
import AppFooter from '@/base/components/Footer/AppFooter'

export default {
  mixins: [AppMixin],
  components: {
    RouterView,
    AppFooter,
    AppHeader,
  },
}
</script>

<style src="./assets/scss/main.scss" lang="scss"></style>
